// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".E53qmrbhjj66z1haFpggU{text-align:center}._3OgVtKnRdkijriWyHXN17A{display:block!important;width:0!important;height:0;opacity:0}", "",{"version":3,"sources":["webpack://./resources/js/components/FormComponents/DeveloperParentEntityFileUpload/DropZone/styles.module.scss"],"names":[],"mappings":"AAAA,uBACI,iBACJ,CAEA,yBACI,uBAAA,CACA,iBAAA,CACA,QAAA,CACA,SACJ","sourcesContent":[".text {\n    text-align: center;\n}\n\n.file_input {\n    display: block !important;\n    width: 0 !important;\n    height: 0;\n    opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": "E53qmrbhjj66z1haFpggU",
	"file_input": "_3OgVtKnRdkijriWyHXN17A"
};
export default ___CSS_LOADER_EXPORT___;
